import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CanvasState {
  feedback: IFeedback | undefined;
  cards: ICard[];
}

const initialState: CanvasState = {
  feedback: undefined,
  cards: [],
};

export const canvasSlice = createSlice({
  name: "canvas",
  initialState,
  reducers: {
    setCanvas: (state: CanvasState, action: PayloadAction<CanvasState>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setCanvas } = canvasSlice.actions;
export default canvasSlice.reducer;
